import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageView from './ImageView';
import { downloadImages, uploadImages } from '../../actions/imageActions';
import { Container, Col, Row } from 'reactstrap';
import ImageUploadForm from './ImageUploadForm';
import { toast } from 'react-toastify';

class ImageViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      files: [],
    };
  }

  componentWillMount() {
    const id = this.props.entryId;
    this.props.actions.downloadImages(id);
  }

  saveImages = (event) => {
    event.preventDefault();
    const { files } = this.state;
    if (files.length > 0) {
      const id = this.props.entryId;
      this.setState({ saving: true });
      if (id) {
        this.props.actions
          .uploadImages(files, id)
          .then(() => {
            toast.success('Images saved.');
            this.setState({ saving: false });
            this.props.actions.downloadImages(this.props.entryId);
          })
          .catch((error) => {
            toast.error('Error saving images.');
            this.setState({ saving: false });
          });
        return;
      }
    } else {
      toast.error('No files selected.');
      return;
    }
  };

  updateFiles = (event) => {
    this.setState({
      files: event.target.files,
    });
  };

  render() {
    const { images } = this.props;
    return (
      <Container fluid={true}>
        <ImageUploadForm
          onSave={this.saveImages}
          updateFiles={this.updateFiles}
          saving={this.state.saving}
        />

        <Row>
          <Col md={3} />
          <Col md={6}>
            <h4 className={'text-center'}>Log Images</h4>
          </Col>
        </Row>
        <Row className="my-4">
          <Col md={3} />
          <Col md={6}>
            {images.length > 0 ? (
              images.map((image) => (
                <ImageView key={image.id} image={{ ...image }} />
              ))
            ) : (
              <h6 className="my-4 text-center">
                No images found for log entry.
              </h6>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

ImageViewer.propTypes = {
  images: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    images: state.images,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ downloadImages, uploadImages }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageViewer);



// WEBPACK FOOTER //
// ./src/components/common/ImageViewer.js